import { LicenseInfo } from '@mui/x-license';

/**
 * MUI DataGrid Pro license key setup.
 *
 * Set VITE_MUI_LICENSE_KEY in your .env file to activate the license.
 * Without a license key, DataGrid Pro renders with a watermark in development
 * and is not permitted in production.
 *
 * Obtain a license at: https://mui.com/x/introduction/licensing/
 */
const LICENSE_KEY = (import.meta as any).env?.VITE_MUI_X_LICENSE_KEY;

// MUI X license format: <32-char hex signature><base64 body>. Some env-injection
// pipelines (e.g., GitHub Actions ${{ }} into an unquoted YAML scalar) strip
// trailing `=` base64 padding, producing a structurally valid but invalid-by-MUI
// key. Repair padding on the body so the bundle is self-healing even if the
// upstream pipeline regresses again.
function repairBase64Padding(key: string): string {
  if (!key || key.length < 33) return key;
  const sig = key.slice(0, 32);
  const body = key.slice(32);
  const padNeeded = (4 - (body.length % 4)) % 4;
  return padNeeded === 0 ? key : sig + body + '='.repeat(padNeeded);
}

if (LICENSE_KEY) {
  LicenseInfo.setLicenseKey(repairBase64Padding(LICENSE_KEY));
} else if ((import.meta as any).env?.DEV) {
  console.warn(
    '[DeepSync] MUI DataGrid Pro license key not set. ' +
    'Add VITE_MUI_LICENSE_KEY to your .env.development.local to remove the evaluation watermark. ' +
    'See https://mui.com/x/introduction/licensing/'
  );
}
